// Step 19 — buyer insight card.
//
// One-per-buyer summary of what the deterministic deal-situation
// aggregate already tells us. Reuses existing data — no invented
// "engagement score" or fabricated probability.

import { Link } from "react-router-dom";

export default function AIBuyerInsight({ row, workspaceId }) {
  if (!row?.acquirer) return null;
  const acq = row.acquirer;
  const comm = row.communication || {};
  const openCount = row.open_items_count ?? 0;
  const isSilent = row.silence?.is_silent;
  const days = row.silence?.days_since_last_outbound;
  const interest = row.interest_signal;

  return (
    <article className="qai-buyer-insight" data-silent={isSilent ? "true" : "false"}>
      <header className="qai-buyer-insight-head">
        <Link
          to={`/deals/${workspaceId}/buyers/${acq.id}`}
          className="qai-buyer-insight-name"
        >
          {acq.name}
        </Link>
        {isSilent && (
          <span className="qai-buyer-insight-silent" title="Ingen respons efter senaste utskick">
            Tyst {days} dagar
          </span>
        )}
      </header>
      {interest?.value && (
        <div className="qai-buyer-insight-interest">
          <span className="qai-buyer-insight-interest-tag">
            {interest.fact_or_inference === "fact" ? "Fakta" : "Slutsats"}
          </span>
          <span>{interest.value}</span>
        </div>
      )}
      <div className="qai-buyer-insight-stats">
        <span>
          {comm.outbound_sent_count ?? 0} skickade · {comm.inbound_count ?? 0} svar
        </span>
        <span>{openCount} öppna poster</span>
      </div>
    </article>
  );
}
